var MileageFilter = function ($filter) {
 var culture =  window.appSettings.currentCulture;
    return function (input) {
        return input.toLocaleString(culture);
    };
};
MileageFilter.$inject = ['$filter'];
module.exports = MileageFilter;
